import { render, staticRenderFns } from "./project-event.vue?vue&type=template&id=62b08ca5&"
import script from "./project-event.vue?vue&type=script&lang=js&"
export * from "./project-event.vue?vue&type=script&lang=js&"
import style0 from "./project-event.vue?vue&type=style&index=0&id=62b08ca5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports